<script>
import IconCross from "@/components/icons/white/IconWhiteCross.vue";

export default {
  name: "MobileMenuButton",
  components: {
    IconCross
  },
  props: {
    expanded: { type: Boolean, required: false, default: false }
  }
};
</script>

<template>
  <button class="mobile-menu" aria-haspopup="true" :aria-expanded="expanded">
    <template v-if="!expanded">
      <span class="mobile-menu__line" aria-hidden="true"></span>
      <span class="mobile-menu__line" aria-hidden="true"></span>
      <span class="mobile-menu__line mobile-menu__line--last" aria-hidden="true"></span>
    </template>
    <template v-else>
      <IconCross class="mobile-menu__cross" role="presentation" />
    </template>
  </button>
</template>
